import { DataListProperty } from './models/Model_CU-029-01';

export const convertDataListProperty = (data: any) => {
    const result: DataListProperty[] = data.map((element: any) => {
        return {
            id: element.id,
            propertyName: element.propertyName,
            propertyImages: element.propertyImages,
            closetStationRequiredMins: element.closetStationRequiredMins,
            stationName: element.stationName,
            lineName: element.lineName,
            floors: element.floors,
            builtAt: element.builtAt,
            residence: element.residence,
            listedPropertiesId: element.listedPropertiesId,
            finalStationName: element.finalStationName,
            listedPropertyId: element.listedPropertiesId,
        };
    });
    return result;
};
